import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router';

import { UserContext } from '../config/UserContext';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const user = useContext(UserContext);
    const location = useLocation();
    const isAuthenticated = (user?.attributes?.sub);
    const destination = location.pathname === '/' ? '/about' : '/signIn';
    const search = `?nextPage=${location.pathname}${location.search}`;
    return isAuthenticated ? (
        children
    ) : (
        <Navigate to={`${destination}${search}`} replace />
    );
}

export default ProtectedRoute;
